// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"78bb4003","787":"0f15b36d"}[chunkId] + ".chunk.js";
};